<template>
  <div class="product-detail-container">
    <el-row class="indbody pro-style">
      <el-col :span="24">
        <div class="nb recom-box">
          <div class="pro-view" id="ym-item">
            <div class="pview-left">
              <div class="ovclear">
                <product-image-slider :product="productDetailInfo.product" />
                
                <div class="fish-detail">
                  <h3>{{productDetailInfo.product.prodName}}</h3>
                  <p></p>
                  <div class="price">
                    <div>市场价：<s>￥{{productDetailInfo.product.otPrice}}</s></div>
                    <div>价格：<span class="redbold">￥<b id="ym-price">{{productDetailInfo.product.price}}</b></span></div>
                  </div>
                  <div class="deliver">
                    <div>配送：
                      <span><b>平台发货</b></span>
                    </div>
                  </div>
                  <div class="spec" id="goods-spec">
                    <div>规格：
                      <li v-for="(item, index) in productDetailInfo.product.productSpecValues" :key="index">
                        {{item.specName}}
                        <span>
                          <b v-if="item.stock > 0">有货</b>
                          <b v-else>无货</b>
                        </span>
                        {{item.otPrice}}
                      </li>
                    </div>
                  </div>
                  <div class="pro-number">
                    <a class="reduce" href="javascript:void(0);" @click="minusProd()">-</a>
                    <input type="text" v-model="goodsNum" id="goods_num" class="result" data-max="99" value="1" maxlength="10">
                    <a class="add" href="javascript:void(0);" @click="addProd()">+</a>
                  </div>
                  <div class="cart-buy">
                    <a href="javascript:void(0);" @click="_buyNow(productDetailInfo.product)" class="buy-btn">立即购买</a>
                    <a href="javascript:void(0);" @click="_addToCart(productDetailInfo.product)" class="cart-btn">加入购物车</a>
                    <a href="javascript:void(0);" @click="_helpBtn()" class="help-btn">咨询</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="pview-right">
              <h2>相关推荐</h2>
              <div class="slider-protj">
                <div class="bd">
                  <ul>
                    <li v-for="(item, index) in productLabelList" :key="index">
                      <a :href="'page.html#/pages/plateform/productDetail?productId=' + item.productId" target="_blank">
                        <img :src="item.coverPhoto" alt=""/>
                      </a>
                      <p>
                        <a :href="'page.html#/pages/plateform/productDetail?productId=' + item.productId" target="_blank">{{item.prodName}}</a>
                        <span>￥{{item.price}}</span>
                      </p>
                    </li>
                  </ul>
                </div>
                <div class="hd">
                  <a href="javascript:void(0);" class="prev"></a>
                  <a href="javascript:void(0);" class="next"></a>
                </div>
              </div>
            </div>
          </div>
          <div class="pro-tab">
            <div class="slide-detail">
              <div class="hdd">
                <ul>
                  <li :class="{'good-detail': true, 'on': activeTab === 0}" @click="switchTab(0)">商品详情</li>
                  <li :class="{'good-evalate': true, 'on': activeTab === 1}" @click="switchTab(1)">
                    客户评价（<em>{{ productAppraiseInfo.length }}</em>）
                  </li>
                </ul>
              </div>
              <div class="bdd">
                <div class="box1">
                  <div class="box1detail" v-show="activeTab === 0">
                    <div class="attr">
                      <ul></ul>
                      <div class="clear"></div>
                    </div>
                    <br>
                    <p style="text-align: center">
                      <span v-html="productDetailInfo.product.content"></span>
                    </p>
                    <p><br></p>
                  </div>
                  <div class="evalute" v-show="activeTab === 1">
                    <h3 class="title">商品评价</h3>
                    <div class="tab-gbw">
                      <div class="bd">
                        <div class="evalute-detail" id="all">
                          <ul>
                            <li style="text-align: center;" v-if="productAppraiseInfo.length === 0">暂无评价~</li>
                            <li v-for="(item, index) in productAppraiseInfo" :key="index" class="appraise-item">
                              <div>
                                <span class="user-name">{{ item.appraiseUserName }} {{ item.createTime }}</span>
                                <text class="time"></text>
                              </div>
                              <p>{{ item.context }}</p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="otherbox" v-show="activeTab === 2">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <input type="hidden" id="goods_id" :value="productId">
    <input type="hidden" id="user_discount" value="">
  </div>
</template>

<script>
import { getProductDetail, listShopAppraise, listProductLabel, saveStoreCart } from '@/api/plateform/productDetail/productDetailApi'
import ProductImageSlider from '@/components/plateform/productDetail/productImageSlider'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ProductDetail',
  components: {
    ProductImageSlider
  },
  data() {
    return {
      productId: this.$route.query.productId,
      activeTab: 0,
      systemInfo: {
        platformName: '',
        contactUrl: '',
        contactPhone: '',
        mallManagerUrl: ''
      },
      productDetailInfo: {
        product: {}
      },
      goodsNum: 1,
      productAppraiseInfo: [],
      productLabelList: [],
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    this._queryProductByProductId(this.productId)
    this._listShopAppraise(this.productId)
    this._loadInformations()
  },
  methods: {
    switchTab(index) {
      this.activeTab = index
    },
    async _queryProductByProductId(productId) {
      try {
        const res = await getProductDetail({
          page: -1,
          row: 100,
          productId: productId
        })
        const product = res.data[0]
        const _productSpecValues = product.productSpecValues
        if (_productSpecValues && _productSpecValues !== 'undefined' && _productSpecValues !== '') {
          _productSpecValues.forEach(item => {
            const _productSpecDetails = item.productSpecDetails
            let _specValue = ''
            if (_productSpecDetails && _productSpecDetails !== 'undefined' && _productSpecDetails !== '') {
              _productSpecDetails.forEach(detail => {
                _specValue += (detail.detailValue + '/')
              })
            }
            item.specValue = _specValue
          })
        }
        this.productDetailInfo.product = product
        this._listProductLabel()
      } catch (error) {
        console.error('获取商品详情失败:', error)
      }
    },
    async _loadInformations() {
      try {
        const res = await this.$http.get('/system.initPlatformData', {
          params: {
            page: 1,
            row: 100
          }
        })
        const _homePageInfo = res.data
        this.systemInfo.platformName = _homePageInfo.data.platformName
        this.systemInfo.contactUrl = _homePageInfo.data.contactUrl
        this.systemInfo.contactPhone = _homePageInfo.data.contactPhone
        this.systemInfo.mallManagerUrl = _homePageInfo.data.mallManagerUrl
      } catch (error) {
        console.error('获取平台信息失败:', error)
      }
    },
    async _listShopAppraise(productId) {
      try {
        const res = await listShopAppraise({
          page: -1,
          row: 100,
          objId: productId,
          objType: '1001'
        })
        this.productAppraiseInfo = res.data
      } catch (error) {
        console.error('获取商品评价失败:', error)
      }
    },
    async _listProductLabel() {
      try {
        const res = await listProductLabel({
          page: -1,
          row: 100,
          labelCd: '942021080038360001',
          shopId: this.productDetailInfo.product.shopId
        })
        this.productLabelList = res.data
      } catch (error) {
        console.error('获取商品标签失败:', error)
      }
    },
    addProd() {
      this.goodsNum = parseInt(this.goodsNum) + 1
    },
    minusProd() {
      if (this.goodsNum <= 1) {
        this.$message.warning('不能再减少了，最小数量为1')
        return
      }
      this.goodsNum = this.goodsNum - 1
    },
    async _addToCart(product) {
      try {
        const res = await saveStoreCart({
          prodName: product.prodName,
          productId: product.productId,
          valueId: product.valueId,
          storeId: product.storeId,
          price: product.price,
          shopId: product.shopId,
          cartNum: this.goodsNum
        })
        if (res.code === 0) {
          this.$message.success('加入购物车成功')
        } else if (res.code === 404) {
          this.$message.warning(res.msg)
        } else {
          this.$message.warning(res.data)
        }
      } catch (error) {
        console.error('加入购物车失败:', error)
        this.$message.error(error)
      }
    },
    _helpBtn() {
      this.$message.info(`咨询电话：${this.systemInfo.contactPhone}，或移步"${this.systemInfo.platformName}"小程序`)
    },
    async _buyNow(product) {
      try {
        const res = await saveStoreCart({
          prodName: product.prodName,
          productId: product.productId,
          valueId: product.valueId,
          storeId: product.storeId,
          price: product.price,
          shopId: product.shopId,
          cartNum: this.goodsNum
        })
        if (res.code === 0) {
          this.$message.success('加入购物车成功')
          this.$router.push({
            path: '/pages/plateform/order',
            query: {
              productId: product.productId,
              shopId: product.shopId,
              valueId: product.valueId,
              goodsNum: 1
            }
          })
        } else if (res.code === 404) {
          this.$message.warning(res.msg)
        } else {
          this.$message.warning(res.data)
        }
      } catch (error) {
        console.error('立即购买失败:', error)
        this.$message.error(error)
      }
    },
    websiteAccessLog() {
      const user = this.$store.getters.userInfo
      const param = user ? {
        loginName: user.name,
        loginId: user.userId,
        accessUrl: window.location.href,
        loginState: '1'
      } : {
        accessUrl: window.location.href,
        loginState: '0'
      }
      
      this.$http.post('websiteAccessLog.saveWebsiteAccessLog', param)
        .then(res => {
          const _json = res.data
          if (_json.code !== 0) {
            console.error('记录访问日志失败')
          }
        })
        .catch(error => {
          console.error('记录访问日志失败:', error)
        })
    }
  }
}
</script>

<style scoped>
.product-detail-container {
  width: 100%;
}
.indbody {
  width: 100%;
}
.pro-style {
  margin: 0 auto;
  max-width: 1200px;
}
</style>